// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hZBR","footer":"styles_footer__bxliJ","passCodeTooltip":"styles_passCodeTooltip__SsSpL"};